"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo } from "react";
import { useSettingsResultObserver } from "@/components/settings-patch-review/use-settings-result-observer";
import { useTenant } from "@/contexts/tenant-provider";
import { AskDecodaStreamRunner } from "@/hooks/ask-decoda/use-ask-decoda-stream-runner";
import { useAskDecodaStore } from "@/stores/ask-decoda-store";
export function AskDecodaRunHost() {
  const $ = _c(11);
  useSettingsResultObserver();
  const {
    tenant
  } = useTenant();
  const tenantSubDomain = tenant?.subDomain;
  const liveRunsByThreadId = useAskDecodaStore(_temp);
  let t0;
  if ($[0] !== liveRunsByThreadId) {
    t0 = Object.values(liveRunsByThreadId);
    $[0] = liveRunsByThreadId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0 || $[3] !== tenantSubDomain) {
    t1 = t0.filter(run => Boolean(tenantSubDomain) && run.tenantSubDomain === tenantSubDomain);
    $[2] = t0;
    $[3] = tenantSubDomain;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const runs = t1;
  let t2;
  let t3;
  if ($[5] !== tenantSubDomain) {
    t2 = () => {
      useAskDecodaStore.getState().ensureTenantScope(tenantSubDomain);
    };
    t3 = [tenantSubDomain];
    $[5] = tenantSubDomain;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] !== runs || $[9] !== tenantSubDomain) {
    t4 = <>{runs.map(run_0 => <AskDecodaStreamRunner key={run_0.runId} run={run_0} tenantSubDomain={tenantSubDomain} />)}</>;
    $[8] = runs;
    $[9] = tenantSubDomain;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function _temp(state) {
  return state.liveRunsByThreadId;
}